import { Controller } from "@hotwired/stimulus";

export default class AccommodationController extends Controller {
  static targets = ["accommodation"];

  static classes = ["show", "hide"];

  static values = {
    bookingRoomAssignmentId: Number,
    accommodationId: Number,
    focusedAssignmentId: Number,
  };

  // Accommodation cards are loaded asynchronously (per booking_room_assignment),
  // so they can connect after the accommodation-request controller has already
  // broadcast the initial focus event. Apply the initial visibility from the
  // server-rendered focused assignment id so a late-arriving card for a
  // non-focused assignment is hidden immediately.
  connect() {
    if (this.hasFocusedAssignmentIdValue) {
      this.applyVisibility(this.focusedAssignmentIdValue);
    }
  }

  showByBookingRoomAssignment(event) {
    this.applyVisibility(event.detail.focusedAssignmentId);
  }

  applyVisibility(focusedAssignmentId) {
    const { classList } = this.accommodationTarget;

    if (focusedAssignmentId === this.bookingRoomAssignmentIdValue) {
      classList.add(this.showClass);
      classList.remove(this.hideClass);
    } else {
      classList.remove(this.showClass);
      classList.add(this.hideClass);
    }
  }
}
